import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import App from "./App";
import './i18n/i18n.js'


import * as serviceWorker from "./serviceWorker";

ReactDOM.render(<React.Suspense fallback=""><App /> </React.Suspense>
    , document.getElementById("root"));

serviceWorker.unregister();
